// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: "Poppins" !important;
  /* background: rgb(45, 48, 56) !important;
  color: white; */
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f0f0f0;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #424242;
}

:is(button, p, input, label, span, select) {
  font-family: "Poppins";
}

:is(h1, h2, h3, h4, h5, h6) {
  font-family: "Poppins" !important;
}

.heightBody {
  height: 100vh;
  font-family: "Poppins" !important;
}

.heightForChild {
  padding-top: 56px;
}

.width-max {
  width: max-content;
}

.hideArrow:after {
  border: none !important;
}

.input-label {
  display: block;
  position: absolute;
  top: 0;
  font-weight: 300;
  font-size: 20px;
  font-family: "Poppins";
}

.loaderAll {
  height: 100vh;
  width: 100%;
}

.loaderAll>img {
  width: 150px;
  height: 150px;
  object-fit: cover;
}

.homePageCardHeading {
  font-family: "Poppins";
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  margin-bottom: 0px;
  height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: nowrap;
}

.homePageCardHeading::after {
  display: none;
}

.homeListImage {
  width: 100%;
  height: 180px;
  object-fit: cover;
  position: relative;
}

.homeListImage::after {
  content: "";
  width: 100%;
  display: block;
  position: absolute;
  bottom: 0;
  height: 70%;
}

.homeListImage.active::after {
  height: 40%;
}

.homeLiveImage {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 3px;
}

.homeListContent {
  z-index: 1;
}

.homeListButton {
  padding: 10px 15px;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}

.homeListButtonText {
  font-family: "Poppins";
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0em;
}


.homeListText {
  font-size: 20px;
  font-family: "Poppins";
}

.homeListPlayIcon {
  width: 10px;
  height: 10px;
}

html {
  touch-action: manipulation;
}

.paddingTop {
  padding-top: 56px;
  min-height: calc(100vh - 24px);
}

.paddingTopone {
  padding-top: 56px;
}

.categoryHover {
  transform: scale(1);
  transition: transform 0.4s ease-in-out;
}

.rs-input {
  font-size: 14px;
}

.errorred {
  color: #ff0000 !important;
  font-size: 14px;
  margin-top: 10px;
  /* display: flex; */
  font-family: 'Poppins';
}

.text-danger {
  color: #ff0000 !important;
}

.border-danger-test {
  border-color: #ff0000 !important;
  --bs-border-opacity: 1 !important;
}

.noRecord {
  display: flex;
  justify-content: center;
  font-size: 17px;
  font-weight: bold;
  padding: 10px;
}

.css-1nmdiq5-menu:hover {
  background-color: #ff0000 !important;
  color: #ff0000 !important;
}

.css-13cymwt-control {
  padding: 5px 0 5px 0;
  border-radius: 5px;
}

.css-b62m3t-container {
  border-radius: 5px;
}

.css-t3ipsp-control {
  padding: 5px 0 5px 0;
  border-radius: 5px;
}

.overlay-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay-icon {
  font-size: 25px;
  color: #ffffff;
}

.thumbnails-images {
  width: auto;
  height: 100px;
}

.modal {
  scrollbar-width: none;
}

.hideArrow::after {
  border: none;
}

.absolute-mobile-link {
  position: absolute;
  inset: 0;
  z-index: 3;
}


.comment-avatar {
  width: 50px;
  height: 50px;
}

.comment-name {
  font-size: 20px;
  font-weight: 600;
  line-height: 36px;
  text-align: left;
}

.comment-text {
  font-size: 18px;
  font-weight: 300;
  line-height: 30px;
  text-align: left;
}

.square {
  background: rgba(130, 130, 130, 0.2);
  background: linear-gradient(to right,
      rgba(130, 130, 130, 0.2) 8%,
      rgba(130, 130, 130, 0.3) 18%,
      rgba(130, 130, 130, 0.2) 33%);
  background-size: 800px 100px;
  animation: wave-squares 2s infinite ease-out;
}

.languageColorAfter::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";
}

.languageText {
  font-family: "Poppins";
  font-size: 25px;
  font-weight: 600;
  line-height: 38px;
  position: absolute;
  bottom: 16px;
  z-index: 1;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}

.mandatory {
  color: #ff0000;
}

.cursor-pointer {
  cursor: pointer;
}

.modal.packageModel {
  background-color: #00000069;
  display: none;
  height: 100%;
  left: 0;
  outline: 0;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9997;
}

.theme-border-bottom-secondary {
  border-bottom: 2px solid rgb(229, 229, 234) !important;
}

.sliderBtnText {
  font-family: "Poppins" !important;
  font-size: 15px !important;
}

.button-bg-color {
  background-color: #0d6efd !important;
  background-color: var(--admin-button-color) !important;
}

.svgIcon {
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: .75px;
}

.rent_video_page_ul_li ul {
  list-style-type: disclosure-closed !important;
}

.maintancesLogo {
  width: 200px;
}

td,
th {
  padding: 0;
  text-align-last: start !important;
}

button,
input,
label,
p,
span {
  font-family: "Poppins";
}

.editdropdown {
  display: inline-block;
  position: relative;
  z-index: 9;
}

.editdropdown-menu a {
  display: block;
  padding: 12px 16px;
  text-decoration: none;
}

.editdropdown-button {
  border: none;
  color: #000;
  cursor: pointer;
  padding: 10px 20px;
}

.editdropdown-menu {
  background-color: #f9f9f9;
  box-shadow: 0 8px 16px 0 #0003;
  display: none;
  left: -150px;
  min-width: 175px;
  position: absolute;
  top: 0;
  z-index: 1;
}

.editdropdown-menu a:hover {
  background-color: rgb(229, 229, 234) !important;
}

.editdropdown:hover .editdropdown-menu {
  display: block;
}

.editdropdown-menu a {
  display: block;
  padding: 12px 16px;
  text-decoration: none;
}

.commonActionPadding {
  cursor: pointer;
  padding: 12px 16px;
}

.commonActionPadding:hover {
  background-color: rgb(229, 229, 234) !important;
}

#pageDropDown {
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(229, 229, 234) !important;
  transition: none !important;
  color: rgb(0, 0, 0) !important;
}

.dropdown-toggle::after {
  display: none !important;
}

.react-bootstrap-table-page-btns-ul {
  justify-content: end;
}

li:first-child {
  list-style: none;
}

li {
  list-style-type: none;
}

.bootstrapTable .page-item.disabled>.page-link {
  opacity: .5;
}

.bootstrapTable .page-link {
  background-color: rgb(255, 255, 255) !important;
  color: rgb(0, 0, 0) !important;
  border-color: rgb(229, 229, 234) !important;
}

@keyframes wave-squares {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}

.Toastify__toast-body {
  font-family: "Poppins";
  font-weight: 500;
}

.css-1nmdiq5-menu:hover {
  background-color: rgb(255, 255, 255) !important;
  color: black !important;
  opacity: 1 !important
}

.css-1nmdiq5-menu {
  background-color: rgb(255, 255, 255) !important;
  opacity: 1 !important;
}

.css-d7l1ni-option,
.css-d7l1ni-option:hover {
  opacity: 1 !important;
}

.border-solid {
  border-style: solid;
}

.bottom-border {
  border-bottom-width: 2px;
  border-bottom-style: solid;
  border-top: 0;
  border-left: 0;
  border-right: 0;
}

.border-width {
  border-width: 1px;
}

.button-color {
  color: #fff !important;
}

.button-bg-color {
  background-color: #4895d1 !important;
}

.css-wsp0cs-MultiValueGeneric {
  font-family: "Poppins" !important;
}

.bg-image-gradian::before {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.Toastify__toast-container {
  z-index: 99999;
}

.before-star::after {
  position: absolute;
  content: "*";
  color: red;
}

button:focus {
  outline: none !important;
}

button.Toastify__close-button {
  background-color: transparent !important;
}

.loaderFixed {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
}

.loader {
  width: 50px;
  aspect-ratio: 1;
  display: grid;
  border-radius: 50%;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5) 30%, transparent 0 70%, rgba(255, 255, 255, 1) 0) 50%/8% 100%, linear-gradient(90deg, rgba(255, 255, 255, 0.25) 30%, transparent 0 70%, rgba(255, 255, 255, 0.75) 0) 50%/100% 8%;
  background-repeat: no-repeat;
  animation: loaderCustom 1s infinite steps(12);
}

.loader::before,
.loader::after {
  content: "";
  grid-area: 1/1;
  border-radius: 100%;
  background: inherit;
  opacity: 0.915;
  transform: rotate(30deg);
}

.loader::after {
  opacity: 0.83;
  transform: rotate(60deg);
}

.header-logo_logo {
  width: 100%;
  height: 100%;
}

@keyframes loaderCustom {
  100% {
    transform: rotate(1turn)
  }
}

.onlineStatus {
  position: fixed;
  top: -50px;
  left: 0;
  right: 0;
  width: 100%;
  text-align: center;
  padding: 10px 15px;
  color: white;
  margin: 0 auto;
  max-width: 190px;
  border-radius: 8px;
  height: 41px;
  z-index: 9999;
  animation: onlineAni 0.08s linear both;
}

/* .css-1nmdiq5-menu:hover{ background-color: none !important;} */
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  appearance: none;
  margin: 0;
}

@keyframes onlineAni {
  0% {
    top: -50px;
  }

  100% {
    top: 70px;
  }
}

.button-btn {
  background-color: #0fcc1c;
}

ul {
  list-style-type: none;
}

a {
  color: rgb(0 0 0) !important;
  text-decoration: none !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,iCAAiC;EACjC;iBACe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EAEzB,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EAOpC;;;mCAGiC;EACjC,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,iCAAiC;AACnC;;AAEA;;;;;EAKE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;EAC/C,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,uBAAuB;EACvB;AACF;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,2OAA2O;EAC3O,4BAA4B;EAC5B,6CAA6C;AAC/C;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sCAAsC;AACxC;;AAEA,iEAAiE;AACjE;;EAIE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n\n* {\n  font-family: \"Poppins\" !important;\n  /* background: rgb(45, 48, 56) !important;\n  color: white; */\n}\n\n::-webkit-scrollbar {\n  width: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: #f0f0f0;\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: #424242;\n}\n\n:is(button, p, input, label, span, select) {\n  font-family: \"Poppins\";\n}\n\n:is(h1, h2, h3, h4, h5, h6) {\n  font-family: \"Poppins\" !important;\n}\n\n.heightBody {\n  height: 100vh;\n  font-family: \"Poppins\" !important;\n}\n\n.heightForChild {\n  padding-top: 56px;\n}\n\n.width-max {\n  width: max-content;\n}\n\n.hideArrow:after {\n  border: none !important;\n}\n\n.input-label {\n  display: block;\n  position: absolute;\n  top: 0;\n  font-weight: 300;\n  font-size: 20px;\n  font-family: \"Poppins\";\n}\n\n.loaderAll {\n  height: 100vh;\n  width: 100%;\n}\n\n.loaderAll>img {\n  width: 150px;\n  height: 150px;\n  object-fit: cover;\n}\n\n.homePageCardHeading {\n  font-family: \"Poppins\";\n  font-size: 13px;\n  line-height: 16px;\n  font-weight: 600;\n  margin-bottom: 0px;\n  height: 16px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  white-space: nowrap;\n}\n\n.homePageCardHeading::after {\n  display: none;\n}\n\n.homeListImage {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  position: relative;\n}\n\n.homeListImage::after {\n  content: \"\";\n  width: 100%;\n  display: block;\n  position: absolute;\n  bottom: 0;\n  height: 70%;\n}\n\n.homeListImage.active::after {\n  height: 40%;\n}\n\n.homeLiveImage {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 3px;\n}\n\n.homeListContent {\n  z-index: 1;\n}\n\n.homeListButton {\n  padding: 10px 15px;\n  border-radius: 5px;\n  width: 100%;\n  text-align: center;\n  margin-bottom: 10px;\n}\n\n.homeListButtonText {\n  font-family: \"Poppins\";\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n  letter-spacing: 0em;\n}\n\n\n.homeListText {\n  font-size: 20px;\n  font-family: \"Poppins\";\n}\n\n.homeListPlayIcon {\n  width: 10px;\n  height: 10px;\n}\n\nhtml {\n  touch-action: manipulation;\n}\n\n.paddingTop {\n  padding-top: 56px;\n  min-height: calc(100vh - 24px);\n}\n\n.paddingTopone {\n  padding-top: 56px;\n}\n\n.categoryHover {\n  transform: scale(1);\n  transition: transform 0.4s ease-in-out;\n}\n\n.rs-input {\n  font-size: 14px;\n}\n\n.errorred {\n  color: #ff0000 !important;\n  font-size: 14px;\n  margin-top: 10px;\n  /* display: flex; */\n  font-family: 'Poppins';\n}\n\n.text-danger {\n  color: #ff0000 !important;\n}\n\n.border-danger-test {\n  border-color: #ff0000 !important;\n  --bs-border-opacity: 1 !important;\n}\n\n.noRecord {\n  display: flex;\n  justify-content: center;\n  font-size: 17px;\n  font-weight: bold;\n  padding: 10px;\n}\n\n.css-1nmdiq5-menu:hover {\n  background-color: #ff0000 !important;\n  color: #ff0000 !important;\n}\n\n.css-13cymwt-control {\n  padding: 5px 0 5px 0;\n  border-radius: 5px;\n}\n\n.css-b62m3t-container {\n  border-radius: 5px;\n}\n\n.css-t3ipsp-control {\n  padding: 5px 0 5px 0;\n  border-radius: 5px;\n}\n\n.overlay-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 9998;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.overlay-icon {\n  font-size: 25px;\n  color: #ffffff;\n}\n\n.thumbnails-images {\n  width: auto;\n  height: 100px;\n}\n\n.modal {\n  scrollbar-width: none;\n}\n\n.hideArrow::after {\n  border: none;\n}\n\n.absolute-mobile-link {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n}\n\n\n.comment-avatar {\n  width: 50px;\n  height: 50px;\n}\n\n.comment-name {\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 36px;\n  text-align: left;\n}\n\n.comment-text {\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 30px;\n  text-align: left;\n}\n\n.square {\n  background: rgba(130, 130, 130, 0.2);\n  background: -webkit-gradient(linear,\n      left top,\n      right top,\n      color-stop(8%, rgba(130, 130, 130, 0.2)),\n      color-stop(18%, rgba(130, 130, 130, 0.3)),\n      color-stop(33%, rgba(130, 130, 130, 0.2)));\n  background: linear-gradient(to right,\n      rgba(130, 130, 130, 0.2) 8%,\n      rgba(130, 130, 130, 0.3) 18%,\n      rgba(130, 130, 130, 0.2) 33%);\n  background-size: 800px 100px;\n  animation: wave-squares 2s infinite ease-out;\n}\n\n.languageColorAfter::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n}\n\n.languageText {\n  font-family: \"Poppins\";\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 38px;\n  position: absolute;\n  bottom: 16px;\n  z-index: 1;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.mandatory {\n  color: #ff0000;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.modal.packageModel {\n  background-color: #00000069;\n  display: none;\n  height: 100%;\n  left: 0;\n  outline: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 9997;\n}\n\n.theme-border-bottom-secondary {\n  border-bottom: 2px solid rgb(229, 229, 234) !important;\n}\n\n.sliderBtnText {\n  font-family: \"Poppins\" !important;\n  font-size: 15px !important;\n}\n\n.button-bg-color {\n  background-color: #0d6efd !important;\n  background-color: var(--admin-button-color) !important;\n}\n\n.svgIcon {\n  fill: none;\n  stroke: currentColor;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: .75px;\n}\n\n.rent_video_page_ul_li ul {\n  list-style-type: disclosure-closed !important;\n}\n\n.maintancesLogo {\n  width: 200px;\n}\n\ntd,\nth {\n  padding: 0;\n  text-align-last: start !important;\n}\n\nbutton,\ninput,\nlabel,\np,\nspan {\n  font-family: \"Poppins\";\n}\n\n.editdropdown {\n  display: inline-block;\n  position: relative;\n  z-index: 9;\n}\n\n.editdropdown-menu a {\n  display: block;\n  padding: 12px 16px;\n  text-decoration: none;\n}\n\n.editdropdown-button {\n  border: none;\n  color: #000;\n  cursor: pointer;\n  padding: 10px 20px;\n}\n\n.editdropdown-menu {\n  background-color: #f9f9f9;\n  box-shadow: 0 8px 16px 0 #0003;\n  display: none;\n  left: -150px;\n  min-width: 175px;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n}\n\n.editdropdown-menu a:hover {\n  background-color: rgb(229, 229, 234) !important;\n}\n\n.editdropdown:hover .editdropdown-menu {\n  display: block;\n}\n\n.editdropdown-menu a {\n  display: block;\n  padding: 12px 16px;\n  text-decoration: none;\n}\n\n.commonActionPadding {\n  cursor: pointer;\n  padding: 12px 16px;\n}\n\n.commonActionPadding:hover {\n  background-color: rgb(229, 229, 234) !important;\n}\n\n#pageDropDown {\n  background-color: rgb(255, 255, 255);\n  border: 1px solid rgb(229, 229, 234) !important;\n  transition: none !important;\n  color: rgb(0, 0, 0) !important;\n}\n\n.dropdown-toggle::after {\n  display: none !important;\n}\n\n.react-bootstrap-table-page-btns-ul {\n  justify-content: end;\n}\n\nli:first-child {\n  list-style: none;\n}\n\nli {\n  list-style-type: none;\n}\n\n.bootstrapTable .page-item.disabled>.page-link {\n  opacity: .5;\n}\n\n.bootstrapTable .page-link {\n  background-color: rgb(255, 255, 255) !important;\n  color: rgb(0, 0, 0) !important;\n  border-color: rgb(229, 229, 234) !important;\n}\n\n@keyframes wave-squares {\n  0% {\n    background-position: -468px 0;\n  }\n\n  100% {\n    background-position: 468px 0;\n  }\n}\n\n.Toastify__toast-body {\n  font-family: \"Poppins\";\n  font-weight: 500;\n}\n\n.css-1nmdiq5-menu:hover {\n  background-color: rgb(255, 255, 255) !important;\n  color: black !important;\n  opacity: 1 !important\n}\n\n.css-1nmdiq5-menu {\n  background-color: rgb(255, 255, 255) !important;\n  opacity: 1 !important;\n}\n\n.css-d7l1ni-option,\n.css-d7l1ni-option:hover {\n  opacity: 1 !important;\n}\n\n.border-solid {\n  border-style: solid;\n}\n\n.bottom-border {\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n  border-top: 0;\n  border-left: 0;\n  border-right: 0;\n}\n\n.border-width {\n  border-width: 1px;\n}\n\n.button-color {\n  color: #fff !important;\n}\n\n.button-bg-color {\n  background-color: #4895d1 !important;\n}\n\n.css-wsp0cs-MultiValueGeneric {\n  font-family: \"Poppins\" !important;\n}\n\n.bg-image-gradian::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.Toastify__toast-container {\n  z-index: 99999;\n}\n\n.before-star::after {\n  position: absolute;\n  content: \"*\";\n  color: red;\n}\n\nbutton:focus {\n  outline: none !important;\n}\n\nbutton.Toastify__close-button {\n  background-color: transparent !important;\n}\n\n.loaderFixed {\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n}\n\n.loader {\n  width: 50px;\n  aspect-ratio: 1;\n  display: grid;\n  border-radius: 50%;\n  background: linear-gradient(0deg, rgba(255, 255, 255, 0.5) 30%, transparent 0 70%, rgba(255, 255, 255, 1) 0) 50%/8% 100%, linear-gradient(90deg, rgba(255, 255, 255, 0.25) 30%, transparent 0 70%, rgba(255, 255, 255, 0.75) 0) 50%/100% 8%;\n  background-repeat: no-repeat;\n  animation: loaderCustom 1s infinite steps(12);\n}\n\n.loader::before,\n.loader::after {\n  content: \"\";\n  grid-area: 1/1;\n  border-radius: 100%;\n  background: inherit;\n  opacity: 0.915;\n  transform: rotate(30deg);\n}\n\n.loader::after {\n  opacity: 0.83;\n  transform: rotate(60deg);\n}\n\n.header-logo_logo {\n  width: 100%;\n  height: 100%;\n}\n\n@keyframes loaderCustom {\n  100% {\n    transform: rotate(1turn)\n  }\n}\n\n.onlineStatus {\n  position: fixed;\n  top: -50px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  text-align: center;\n  padding: 10px 15px;\n  color: white;\n  margin: 0 auto;\n  max-width: 190px;\n  border-radius: 8px;\n  height: 41px;\n  z-index: 9999;\n  animation: onlineAni 0.08s linear both;\n}\n\n/* .css-1nmdiq5-menu:hover{ background-color: none !important;} */\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n@keyframes onlineAni {\n  0% {\n    top: -50px;\n  }\n\n  100% {\n    top: 70px;\n  }\n}\n\n.button-btn {\n  background-color: #0fcc1c;\n}\n\nul {\n  list-style-type: none;\n}\n\na {\n  color: rgb(0 0 0) !important;\n  text-decoration: none !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
